module.exports = __webpack_public_path__ + "img/yuandan.db9f834d.png";